import dayjs from "dayjs";
import i18next from "i18next";

const I18N_ResourceGanttTimelineFormatDate = (start, end) => {
  const language = i18next.language

  function formatDate(dateString, lang) {
    switch(lang) {
      case "ja":
        return dayjs(dateString).format("M月D日(ddd) H時mm分")
      case "en":
        return dayjs(dateString).format("M/D(ddd) H:mm")
      case "zh":
        return dayjs(dateString).format("M月D日(ddd) H时mm分")
      default:
        return dayjs(dateString).format("D/M(ddd) H:mm")
    }
  }
  return formatDate(start, language) + " - " + formatDate(end, language);
}

const I18N_ProcessHeaderDate = (date, unit) => {
  const language = i18next.language
  switch (unit) {
    case "日月年":
    {
      switch(language) {
        case "ja":
        case "zh":
          return dayjs(date).format("YYYY年 M月 D日 (ddd)")
        case "en":
        default:
          return dayjs(date).format("D MMM YYYY")
      }
    }
    case "月年":
    {
      switch(language) {
        case "ja":
        case "zh":
          return dayjs(date).format("YYYY年 M月")
        case "en":
        default:
          return dayjs(date).format("MMM YYYY")
      }
    }
    case "曜日":
      return dayjs(date).format("ddd")
    case "月":
      return dayjs(date).format("MMM")
    case "年":
      {
        switch(language) {
          case "ja":
          case "zh":
            return dayjs(date).format("YYYY年")
          case "en":
          default:
            return dayjs(date).format("YYYY")
        }
      }

    default:
      break;
  }
}

export { I18N_ResourceGanttTimelineFormatDate, I18N_ProcessHeaderDate };
